// This same import must be in the file that it's being used otherwise it will cry
import {FaUsers, FaRegListAlt, FaRegObjectGroup, FaRegNewspaper, FaFileUpload, FaBuffer, FaElementor} from 'react-icons/fa';
import FormCodes from '../constants/FormCodes';

// This array will hold what icon to use for the card, what route to send to, and what the ID is if we need it ever
const reportCards = [
  {name: 'Client Reports', id: FormCodes.CLIENT_REPORTS, icon: FaUsers, route: 'client'},
  {name: 'Survey Reports', id: FormCodes.SURVEY_REPORTS, icon: FaRegListAlt, route: 'survey'},
  {name: 'Analysis Reports - Funeral', id: FormCodes.ANALYSIS_FUNERAL, icon: FaRegNewspaper, route: 'analysis/funeral'},
  {name: 'Analysis Reports - Cremation', id: FormCodes.ANALYSIS_CREMATION, icon: FaBuffer, route: 'analysis/cremation'},
  {name: 'Analysis Reports - PreNeed', id: FormCodes.ANALYSIS_PRENEED, icon: FaElementor, route: 'analysis/preneed'},
  {name: 'Opportunity Plan', id: FormCodes.OPPORTUNITY_PLAN, icon: FaRegObjectGroup, route: 'opportunity'},
  {name: 'Import Report', id: FormCodes.IMPORT, icon: FaFileUpload, route: 'import'},
];

const getReportCard = id => {
  return reportCards.find(card => card.id === id);
};

export {getReportCard};
